import React, { Component } from "react";
import Flag from "react-flagkit";
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { SearchLink } from "./SearchLink";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const ThreatList = (props) => {
  const threatItem = props.data;

  if (threatItem && threatItem.threat_lists && threatItem.threat_lists.length) {
    let threatListsJSX = threatItem.threat_lists.map((tList, index) => (
      <Col className={index} sm={12} md={6} xl={4}>
        <a href={tList.url} target="_blank">
          {tList.title}
        </a>
      </Col>
    ));
    return (
      <div className="pl-1">
        <h5>Threat List:</h5>
        <div className="pl-3">
          <Row>{threatListsJSX}</Row>
        </div>
      </div>
    );
  }
  return <></>;
};

class SearchResultByDomain extends Component {
  validateLocationArray = (values) => {
    let result = [];
    for (let i = 0; i < values.length; i++) {
      if (values[i]){
        result.append(values[i]);
      }
    }
    return result;
  }

  renderContact = (c) => (
    <div className="pl-3">
      <p>{c.name ? (<><b>Name : </b> {c.name}</>) : ""}</p>
      <p>{c.email ? (<><b>Email : </b> {c.email}</>) : ""}</p>
      <p>{c.organization ? (<><b>Organization :</b> {c.organization}</>) : ""}</p>
      <p>{this.validateLocationArray([c.street, c.city, c.state, c.country_name, c.postal_code]).length > 0 ? (<><b>Location: </b> {this.validateLocationArray([c.street, c.city, c.state, c.country_name, c.postal_code]).filter((x) => x).join(", ")}</>) : ""}</p>
      <p>{c.phone_number ? (<><b>Phone Number : </b> {c.phone_number}</>) : ""}</p>
    </div>
  );

  getFlag = (c) => {
    let fn = undefined;
    if (c.country_code) fn = c.country_code;
    else if (c.country_name && c.country_name.length === 2) fn = c.country_name;

    if (undefined === fn) return <div></div>;

    if ("UK" === fn) fn = "GB";

    return <Flag country={fn} />;
  };

  formatDateEvent = (dateExample) => {
    const dateFinal = new Date(dateExample);
    const finalResult = dateFinal.getFullYear()+'-' + (dateFinal.getMonth()+1) + '-'+dateFinal.getDate() + " "+ dateFinal.getHours()+":"+dateFinal.getMinutes()+":"+dateFinal.getSeconds();
    return finalResult;
  }

  stringFormatUppercase = (word) => {
    const string_final = word[0].toUpperCase() + word.substr(1);

    return string_final;
  };

  render() {
    const { data, threat_item, record_item } = this.props;
    const {
      domain_name,
      domain_age,
      contact_email,
      status,
      registrar_name,
      registrar_ianaid,
      whois_server,
      created_date,
      updated_date,
      expires_date,
      registrant,
      administrative_contact,
      technical_contact,
      name_servers,
      records,
      nameservers,
      links,
      events,
      notices,
    } = data;

    const { country_code, risk_level, threat } = record_item;

    let dns_info_list = [];

    dns_info_list.push(
      <p>
        <b>Domain Name : </b><SearchLink searchTerm={domain_name} />
      </p>
    );

    if (domain_age)
      dns_info_list.push(
        <p>
          <b>Domain Age : </b><i>{domain_age} (days)</i>
        </p>
      );
    if (contact_email)
      dns_info_list.push(
        <p>
          <b>Contact Email : </b><i>{contact_email}</i>
        </p>
      );
    if (whois_server)
      dns_info_list.push(
        <p>
          <b>WhoIs Server : </b><i>{whois_server}</i>
        </p>
      );
    if (registrar_name)
      dns_info_list.push(
        <p>
          <b>Registrar Name : </b><i>{registrar_name}</i>
        </p>
      );
    if (registrar_ianaid)
      dns_info_list.push(
        <p>
          <b>Registrar IANAID : </b><i>{registrar_ianaid}</i>
        </p>
      );
    if (created_date)
      dns_info_list.push(
        <p>
          <b>Created Date : </b><i>{created_date}</i>
        </p>
      );
    if (updated_date)
      dns_info_list.push(
        <p>
          <b>Updated Date : </b><i>{updated_date}</i>
        </p>
      );
    if (expires_date)
      dns_info_list.push(
        <p>
          <b>Expires Date : </b><i>{expires_date}</i>
        </p>
      );

    return (
      <div>
        <div className="d-flex justify-content-start align-items-center flex-wrap">
          <h5 className="mr-3">
            <b>Domain: </b><SearchLink searchTerm={domain_name} />
          </h5>
          {country_code ? <Flag country={country_code} className="mr-3" /> : ""}
          <h5 className="mr-3"><b>Risk Level : </b>{risk_level || 1}</h5>
          <h5 className={threat ? "mr-3" : ""}>
            {threat ? "Threat : " + threat : ""}
          </h5>
        </div>
        <h5><b>Domain Information :</b></h5>
        <div className="pl-3">
          <Row>
            {dns_info_list.map((item, index) => (
              <Col key={index+"dnsi1"} sm={12} md={6} xl={6}>
                {item}
              </Col>
            ))}
          </Row>
        </div>
        <ThreatList data={threat_item} />
        {status ? (
          <div>
            { //status ? <h5>Status : {status && status.join(" & ")}</h5> : <> </>
            
        }
          </div>
        ) : (
          <div />
        )}
        {registrant ? (
          <div>
            <div className="d-flex align-items-center">
              <h5 className="mr-3"><b>Registrant :</b></h5>
              {this.getFlag(registrant)}
            </div>
            {this.renderContact(registrant)}
          </div>
        ) : (
          <div />
        )}
        {administrative_contact ? (
          <div>
            <div className="d-flex align-items-center">
              <h5 className="mr-3"><b>Administrative Contact :</b></h5>
              {this.getFlag(administrative_contact)}
            </div>
            {this.renderContact(administrative_contact)}
          </div>
        ) : (
          <div />
        )}
        {technical_contact ? (
          <div>
            <div className="d-flex align-items-center">
              <h5 className="mr-3"><b>Technical Contact :</b></h5>
              {this.getFlag(technical_contact)}
            </div>
            {this.renderContact(technical_contact)}
          </div>
        ) : (
          <div />
        )}
        {name_servers ? (
          <div>
            <h5 className="mr-3"><b>Name Servers :</b></h5>
            <div className="pl-3">
              {name_servers.host_names.length > 0 ? (
                <div>
                  <p>Host Names :</p>
                  <div className="pl-3">
                    <Row>
                      {name_servers.host_names.map((item, index) => (
                        <Col key={index} sm={12} md={6} xl={4}>
                          <p>
                            <SearchLink searchTerm={item} />
                          </p>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              ) : (
                <div />
              )}
              {name_servers.ips.length > 0 ? (
                <div>
                  <p>IPs :</p>
                  <div className="pl-3">
                    <Row>
                      {name_servers.ips.map((item, index) => (
                        <Col key={index} sm={12} md={6} xl={4}>
                          <p>{item}</p>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              ) : (
                <div />
              )}
            </div>
          </div>
        ) : (
          <div />
        )}

        {nameservers ? (
          <div>
            <h5 className="mr-3"><b>Name Servers:</b></h5>
            <div className="pl-3">
              {nameservers.length > 0 ? (
                <div>
                  <p><b>Host Names:</b></p>
                  <div className="pl-3">
                    <Row>
                      {nameservers.map((item, index) => (
                        <>
                          <Col key={index+"hn1"} sm={12} md={6} xl={3}>
                            <p>
                              <b> Host Name {index+1} :</b>
                            </p>
                          </Col>
                          <Col key={index+"hn2"} sm={12} md={6} xl={3}>
                            <p>
                              <SearchLink searchTerm={item?.ldhName} />
                            </p>
                          </Col>
                      </> 
                      ))}
                    </Row>
                  </div>
                </div>
              ) : (
                <div />
              )}
            </div>
          </div>
        ) : (
          <div />
        )}
        {links ? (
          <div>
            <h5 className="mr-3"><b>Links:</b></h5>
            <div className="pl-3">
              {links.length > 0 ? (
                <div>
                  <div className="pl-3">
                    <Row>
                      {links.map((item, index) => (
                        <>
                          <Col key={index+"links1"} sm={6} md={6} xl={4}>
                            <p>
                              <b>{this.stringFormatUppercase(item.rel)}</b>
                            </p>
                          </Col>
                          <Col key={index+"links2"} sm={6} md={6} xl={8}>
                          <p>
                            <SearchLink searchTerm={item?.value} />
                          </p>
                          </Col>
                        </>
                      ))}
                    </Row>
                  </div>
                </div>
              ) : (
                <div />
              )}
            </div>
          </div>
        ) : (
          <div />
        )}
        {events ? (
          <div>
            <h5 className="mr-3"><b>Events:</b></h5>
            <div className="pl-3">
              {events.length > 0 ? (
                <div>
                  <div className="pl-3">
                    <Row>
                      {events.map((item, index) => (
                        <>
                          <Col key={index+"eve1"} sm={6} md={6} xl={6}>
                            <p>
                              <b>{this.stringFormatUppercase(item.eventAction)}</b>
                            </p>
                          </Col>
                          <Col key={index+"eve2"} sm={6} md={6} xl={6}>
                          <p>
                            {this.formatDateEvent(item.eventDate)}
                          </p>
                          </Col>
                        </>
                      ))}
                    </Row>
                  </div>
                </div>
              ) : (
                <div />
              )}
            </div>
          </div>
        ) : (
          <div />
        )}

        {notices ? (
          <div>
            <h5 className="mr-3"><b>Notices:</b></h5>
            <div className="pl-3">
              {notices.length > 0 ? (
                <div>
                  <div className="pl-3">
                    <Row>
                      {notices.map((item, index) => (
                        <>
                          <Col key={index+"not1"} sm={6} md={6} xl={2}>
                            <p>
                              <b>Title {index+1}: </b>
                            </p>
                          </Col>
                          <Col key={index+"not2"} sm={6} md={6} xl={4}>
                          <p>
                            {item.title}
                          </p>
                          </Col>
                          <Col key={index+"not3"} sm={6} md={6} xl={2}>
                            <p>
                              <b>Description {index+1}: </b>
                            </p>
                          </Col>
                          <Col key={index+"not4"} sm={6} md={6} xl={4}>
                          <p>
                            {item.description}
                          </p>
                          </Col>
                          <Col key={index+"not5"} sm={6} md={6} xl={2}>
                            <p>
                              <b>Link {index+1}: </b>
                            </p>
                          </Col>
                          <Col key={index+"not6"} sm={6} md={6} xl={10}>
                          <p>
                            <SearchLink searchTerm={item?.links[0]?.href} />
                          </p>
                          </Col>
                        </>
                      ))}
                    </Row>
                  </div>
                </div>
              ) : (
                <div />
              )}
            </div>
          </div>
        ) : (
          <div />
        )}
        <h5><b>Records</b></h5>
        {records && records.a && records.a.length > 0 ? (        
          <div className="pl-3">
            <h5><b>A Records :</b></h5>
            <div className="pl-3">
              <Row>
                {records.a.map((item, index) => (
                  <Col key={index+"rec1"} sm={12} md={6} xl={4}>
                    <p>
                      <SearchLink searchTerm={item.data} />
                    </p>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        ) : (
          <div />
        )}
        {records && records.mx && records.mx.length > 0 ? (
          <div className="pl-3">
            <h5>MX Records :</h5>
            <div className="pl-3">
              <Row>
                {records.mx.map((item, index) => (
                  <Col key={index} sm={12} md={6} xl={4}>
                    <p>
                      <SearchLink searchTerm={item.data.replace(/.$/, "")} />
                    </p>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        ) : (
          <div />
        )}
        {records && records.cname && records.cname.length > 0 ? (
          <div className="pl-3">
            <h5>CNAME Records :</h5>
            <div className="pl-3">
              <Row>
                {records.cname.map((item, index) => (
                  <Col className={index} sm={12} md={6} xl={4}>
                    <p>
                      <SearchLink searchTerm={item.data} />
                    </p>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultByDomain);
